import { Container, Box } from '@mui/material';

function PrivacyPolicy() {
    return (
        <>
            <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
                <h1 className='pp-1'>
                    Privacy Policy
                </h1>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Introduction
                    </h5>
                    <p className='pp-3'>
                        This Privacy Policy outlines the practices of NVXO Wallet ("we," "our," or "us") regarding the collection, use, sharing, and protection of personal information collected from users of our services, including our website, mobile applications, and related products and services (collectively, the "Services").
                    </p>
                    <p className='pp-3'>
                        By using our Services, you agree to the terms of this Privacy Policy and our Terms of Use, and you consent to the collection, use, disclosure, and retention of your information as described herein. If you do not agree with any part of this Privacy Policy or our Terms of Use, please refrain from using our Services.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Information Collection
                    </h5>
                    <p className='pp-3'>
                        We collect information about you in various ways, including:
                    </p>
                    <p className='pp-3'>
                        <strong>Information You Provide Us:</strong> This includes identity details (e.g., name, username), contact information (e.g., email address, phone number), profile data, financial details (e.g., credit card information), transaction history, usage data, marketing preferences, and technical information (e.g., Ethereum wallet address).
                    </p>
                    <p className='pp-3'>
                        <strong>Information Collected by Infura:</strong> When using Infura as your default RPC provider in NVXO Wallet, your IP address and Ethereum wallet address are collected. However, this data is not collected if you connect to NVXO using your own Ethereum node or an external RPC provider.
                    </p>
                    <p className='pp-3'>
                        <strong>Additional Service Information:</strong> This includes identity verification documents, Anti-Money Laundering (AML) and Know Your Customer (KYC) data, source of funds information, and details related to token holdings.
                    </p>
                    <p className='pp-3'>
                        <strong>Information from Third Parties:</strong> We may receive information about you from third-party sources, which may be combined with data collected through our Services.
                    </p>
                    <p className='pp-3'>
                        <strong>Automatically Collected Information:</strong> We may collect certain information automatically, such as your IP address, device type, and pages visited, to improve our Services.
                    </p>
                    <p className='pp-3'>
                        <strong>Cookies:</strong> We use cookies and similar technologies to analyze trends, manage our Sites, track user activity, and gather demographic information. You can control cookie preferences through your browser settings.

                    </p>
                </Box>


                <Box mt={3}>
                    <h5 className='pp-2'>
                        Use of Personal Information
                    </h5>
                    <p className='pp-3'>
                        We use your personal information for the following purposes:
                    </p>
                    <ul>
                        <li className='pp-3'>Providing and improving our Services</li>
                        <li className='pp-3'>Ensuring compliance with laws and regulations</li>
                        <li className='pp-3'>Communicating updates, events, and promotions</li>
                        <li className='pp-3'>Optimizing our platform and user experience</li>
                        <li className='pp-3'>Implementing fraud prevention and safety measures</li>
                        <li className='pp-3'>Sharing testimonials or endorsements with your consent</li>
                    </ul>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Sharing of Personal Information
                    </h5>
                    <p className='pp-3'>
                        We do not share your personal information with third parties without your consent, except in the following cases:
                    </p>
                    <ul>
                        <li className='pp-3'>With our affiliates and subsidiaries</li>
                        <li className='pp-3'>In the event of business transfers or transactions</li>
                        <li className='pp-3'>To comply with legal obligations or law enforcement requests</li>
                        <li className='pp-3'>With professional advisors and service providers</li>
                        <li className='pp-3'>With other companies or entities, with your permission</li>
                    </ul>
                    <p className='pp-3'>
                        We may share aggregated or anonymized data for analytical purposes.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        International Transfers
                    </h5>
                    <p className='pp-3'>
                        Your personal information may be transferred to or from locations outside of your jurisdiction, including the United States, where privacy laws may differ.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Security of Information
                    </h5>
                    <p className='pp-3'>
                        We follow industry-standard security protocols to protect data shared through our Services. However, we cannot guarantee the security of data transmitted over the Internet.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Your Information Choices
                    </h5>
                    <p className='pp-3'>
                        You can access, update, correct, or delete your information by contacting us at <a style={{ textDecoration: "underline" }} href="mailto:Hello@nvxo.io">Hello@nvxo.io</a> . You may also manage your contact preferences and opt out of certain communications.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Eligibility
                    </h5>
                    <p className='pp-3'>
                        If you are a minor, you may use our Services only with parental or guardian consent.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Marketing Communications and Opt-Out
                    </h5>
                    <p className='pp-3'>
                        You can opt out of marketing communications by following the instructions in our emails or contacting us directly. However, you may continue to receive non-marketing communications related to your account or Services.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Third-Party Links
                    </h5>
                    <p className='pp-3'>
                        Our Privacy Policy does not apply to the privacy practices of third-party websites linked from our Sites. We encourage you to review their privacy policies.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Co-Branded Websites
                    </h5>
                    <p className='pp-3'>
                        This Privacy Policy does not cover co-branded websites. We recommend reviewing the privacy notices on each co-branded site you visit.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Changes to This Privacy Policy
                    </h5>
                    <p className='pp-3'>
                        We may update this Privacy Policy periodically. By continuing to use our Services, you accept any changes made to this policy.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Data Protection Officer
                    </h5>
                    <p className='pp-3'>
                        For data protection inquiries or concerns, you can reach our Data Protection Officer at <a style={{ textDecoration: "underline" }} href="mailto:Hello@nvxo.io">Hello@nvxo.io</a>
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Contact Us
                    </h5>
                    <p className='pp-3'>
                        For any questions or complaints about this policy, please contact us at <a style={{ textDecoration: "underline" }} href="mailto:Hello@nvxo.io">Hello@nvxo.io</a>
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Notice to EU Data Subjects
                    </h5>
                    <p className='pp-3'>
                        EU data subjects have specific rights under the General Data Protection Regulation (GDPR) regarding their personal information. You may request actions related to your data or file a complaint with your data protection authority or us.
                    </p>
                </Box>

                <Box mt={3}>
                    <h5 className='pp-2'>
                        Cross-Border Data Transfers
                    </h5>
                    <p className='pp-3'>
                        Your information may be transferred to the United States or other countries, where we ensure appropriate safeguards are in place to protect your data.
                    </p>
                </Box>
            </Container>
        </>
    );
}

export default PrivacyPolicy;
